import { defaultTheme } from 'react-admin';
import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  ...defaultTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: '#7367f0',
      light: '#9e95f5',
      dark: '#5549d9',
    },
    secondary: {
      main: '#ff9f43',
      light: '#ffb976',
      dark: '#e68a3a',
    },
    background: {
      default: '#161d31',
      paper: '#283046',
    },
    text: {
      primary: '#d0d2d6',
      secondary: '#676d7d',
    },
    success: {
      main: '#28c76f',
    },
    error: {
      main: '#ea5455',
    },
    warning: {
      main: '#ff9f43',
    },
    info: {
      main: '#00cfe8',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#161d31',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: '#283046',
          borderRadius: 12,
          boxShadow: '0 4px 24px 0 rgba(0, 0, 0, 0.24)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: '#283046',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 8,
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(115, 103, 240, 0.4)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#161d31',
            borderRadius: 8,
            '& fieldset': {
              borderColor: '#404656',
            },
            '&:hover fieldset': {
              borderColor: '#7367f0',
            },
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderColor: '#404656',
          color: '#d0d2d6',
        },
        head: {
          backgroundColor: '#242b3d',
          fontWeight: 600,
          textTransform: 'uppercase',
          fontSize: '0.75rem',
          letterSpacing: '0.5px',
          color: '#676d7d',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#242b3d !important',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#283046',
          backgroundImage: 'none',
          boxShadow: '0 4px 24px 0 rgba(0, 0, 0, 0.24)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#283046',
          borderRight: 'none',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          margin: '2px 8px',
          '&.Mui-selected': {
            backgroundColor: 'rgba(115, 103, 240, 0.16)',
            '&:hover': {
              backgroundColor: 'rgba(115, 103, 240, 0.24)',
            },
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: '#d0d2d6',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#676d7d',
        },
      },
    },
  },
});
